







import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Description extends Vue {
  @Prop(String) private title!: string;
  @Prop(String) private desc!: string | undefined;

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--headline-color": this.$store.state.globalCss.colors.headline.color
    };
  }
}
